// Needed for redux-saga es6 generator support
import 'babel-polyfill';

// Import CSS reset and Global Styles
import './index.scss';

import bindRaven from './raven';
import enableSemantic from './semantic';
import hookRouter from './router';
import bindPlugins from './plugins';

// Enabling Raven error capturing
bindRaven();

// Enabling Semantic UI components
enableSemantic();

// Loading plugins
bindPlugins();

// Hooking router
hookRouter();



// WEBPACK FOOTER //
// ./src/index.js